import { AnimatePresence } from "framer-motion"
import { toast } from "../../../utils/notify";
import { updateRiskTreatmentPlanApi } from "../../../services/axios/AuthApis/RisksManagementApis";
import { useState } from "react";
import { XCircleIcon } from "@heroicons/react/24/outline";
import UploadFileModal from "../../ui/UploadFileModal";
import { useSelector } from "react-redux";

export const TreatmentFileUpload = ({ showUploadFile, setShowUploadFile, selectedTreatment }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const userDetail = useSelector((state) => state.user);
  const handleTreatmentUploadFile = async () => {
    if (!selectedFile) {
      toast.error("Please select a file to upload");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("treatmentFile", selectedFile);
      formData.append("employee_id", userDetail?.user?.id)
      const response = await updateRiskTreatmentPlanApi(formData, selectedTreatment.id);
      toast.success("File uploaded successfully");
      setShowUploadFile(false);
    } catch (error) {
      toast.error("Failed to upload file. Please try again.");
    }
  }
  return (
    <AnimatePresence>
      {showUploadFile && (
        <UploadFileModal
          showUploadFile={showUploadFile}
          setShowUploadFile={setShowUploadFile}
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          handleUploadFile={handleTreatmentUploadFile}
          title="Upload Verification Document"
          subtitle="Attach evidence for this risk treatment"
          acceptedFileTypes=".pdf,.doc,.docx,.png,.jpg,.jpeg"
          maxFileSize={2}
          fileTypeLabel={["PDF", "DOC", "DOCX", "PNG", "JPG", "JPEG"]}
        />
      )}
    </AnimatePresence>
  )
}